// Mock Auth Provider for Local Development
import React, { createContext, useContext } from 'react';
import { useAuth } from 'react-oidc-context';
import { LOCAL_DEV_MODE } from './config';

const MockAuthContext = createContext();

// Mock user data for local development
const mockUser = {
  profile: {
    email: 'developer@amazon.com',
    name: 'Local Developer',
    given_name: 'Local',
    family_name: 'Developer',
    sub: 'mock-user-id-123'
  },
  access_token: 'mock-access-token',
  id_token: 'mock-id-token'
};

export const MockAuthProvider = ({ children }) => {
  const authValue = {
    isLoading: false,
    isAuthenticated: true,
    user: mockUser,
    error: null,
    signinRedirect: () => {
      console.log('[LOCAL DEV] Mock signin redirect - already authenticated');
    },
    signoutRedirect: () => {
      console.log('[LOCAL DEV] Mock signout redirect');
    },
    removeUser: () => {
      console.log('[LOCAL DEV] Mock remove user');
    }
  };

  return (
    <MockAuthContext.Provider value={authValue}>
      {children}
    </MockAuthContext.Provider>
  );
};

// Smart auth hook that uses mock in local dev, real auth otherwise
export const useAppAuth = () => {
  // Always call both hooks to follow React hooks rules
  const realAuth = useAuth();
  const mockContext = useContext(MockAuthContext);
  
  if (LOCAL_DEV_MODE) {
    console.log('🔧 [LOCAL DEV MODE] Using mock authentication');
    // Always return mock auth state for local development
    return {
      isLoading: false,
      isAuthenticated: true,
      user: mockUser,
      error: null,
      signinRedirect: () => console.log('[LOCAL DEV] Mock signin - bypassed'),
      signoutRedirect: () => console.log('[LOCAL DEV] Mock signout - bypassed'),
      removeUser: () => console.log('[LOCAL DEV] Mock remove user - bypassed')
    };
  }
  
  // Return real auth for production environments
  return realAuth;
};
